import { CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import ReactDataGrid from 'react-data-grid';
import './ninjatable.css';
import './templates.css';

const NinjaTableGrid = (props) => {
  const {
    // Pre defined styles, saved in styles variable
    template = 'outerreporting',
    loading,
    dynamicHeight = true,
    maxHeight,
    disableFooter,
    rowHeight,
    sortColumns,
    onSortColumnsChange,
    ...rest
  } = props;

  /* Theme manager, get predefined from template */
  const theme = styles[template];

  /**
   * Returns row key
   */
  const rowKeyGetter = (row) => {
    return row.id;
  };

  if (dynamicHeight) {
    const rowHeight = theme.rowHeight;
    const headerHeight = theme.headerRowHeight;

    let summaryHeight = 0;
    if (props.summaryRows.length) {
      const summaryRowHeightVar = theme.styles['--nnj-summary-cell-height' || '40px'];
      if (summaryRowHeightVar) {
        summaryHeight = parseInt(summaryRowHeightVar.replace('px', ''), 10);
      } else {
        summaryHeight = rowHeight;
      }
    }

    theme.styles.minHeight = rowHeight * props.rows.length + headerHeight + summaryHeight + 12;
  }

  if (theme.styles.minHeight > 1000) {
    theme.styles.minHeight = 200;
    theme.styles.maxHeight = 1000;
  }

  if (!maxHeight) {
    if (props.rows.length === 0) {
      theme.styles.minHeight = 200;
      theme.styles.height = theme.rowHeight * 2 + theme.headerRowHeight + 8;
    } else {
      theme.styles.height = theme.rowHeight * props.rows.length + theme.headerRowHeight + 8;
    }
    theme.styles.maxHeight = 1000;
  }

  if (
    !disableFooter &&
    (template === 'widget' || 'channels-widget') &&
    maxHeight &&
    theme.styles.minHeight
  ) {
    theme.styles.minHeight = null;
    theme.styles.height = maxHeight - 90;
  }

  if (maxHeight && theme.styles.minHeight) {
    theme.styles.minHeight = null;
    theme.styles.height = maxHeight - 40;
  }

  return (
    <div
      className={clsx('nnj-grid flex flex-col', template, {
        loading: loading,
        stripped: 'stripped',
      })}
      style={{ ...theme.styles }}
    >
      {/* Table loading indicator, Currently handled by only css */}
      <LoadingIndicator />
      {/* <DraggableComponent> */}
      <ReactDataGrid
        className={props.rows.length <= 0 ? 'flex-1 nnj-grid noResult ' : 'flex-1 nnj-grid '}
        headerRowHeight={theme.headerRowHeight}
        rowKeyGetter={rowKeyGetter}
        {...rest}
        cellNavigationMode='NONE'
        rowHeight={rowHeight || theme.rowHeight}
        bottomSummaryRows={props.summaryRows.length > 0 ? props.summaryRows : undefined}
        sortColumns={sortColumns}
        onSortColumnsChange={onSortColumnsChange}
        cellRenderer
      />
      {/* </DraggableComponent> */}
    </div>
  );
};

const LoadingIndicator = () => {
  return (
    <div className='loading-div flex-center'>
      <CircularProgress />
    </div>
  );
};

const styles = {
  outerreporting: {
    backgroundColor: 'white',
    styles: {
      '--nnj-header-bgcolor': 'white',
      '--nnj-row-bgcolor': 'white',
      '--nnj-header-cell-height': '50px',
      '--nnj-header-font-size': '11px',
      '--nnj-header-color': 'black',
      height: 'auto !important',
    },
    headerRowHeight: 50,
    rowHeight: 40,
  },
  creativeReporting: {
    backgroundColor: 'white',
    styles: {
      '--nnj-header-bgcolor': 'white',
      '--nnj-row-bgcolor': 'white',
      '--nnj-header-cell-height': '50px',
      '--nnj-header-font-size': '11px',
      '--nnj-header-color': 'black',
      height: 'auto !important',
    },
    headerRowHeight: 50,
    rowHeight: 45,
  },
  crm: {
    backgroundColor: 'white',
    styles: {
      '--nnj-header-bgcolor': 'white',
      '--nnj-row-bgcolor': 'white',
      '--nnj-header-cell-height': '50px',
      '--border-right': '1px solid #F2F2F2',
      '--nnj-summary-cell-height': '55px',
      '--nnj-header-font-size': '11px',
      '--nnj-row-border-bottom': '1px solid #E5E5E5',
    },
    headerRowHeight: 50,
    rowHeight: 54,
  },
  retention: {
    backgroundColor: 'white',
    styles: {
      '--nnj-header-bgcolor': 'white',
      '--nnj-row-bgcolor': 'white',
      '--nnj-header-cell-height': '50px',
      '--nnj-summary-cell-height': '70px',
      '--nnj-header-font-size': '11px',
    },
    headerRowHeight: 50,
    rowHeight: 40,
  },
  conversion: {
    backgroundColor: 'white',
    styles: {
      '--nnj-header-bgcolor': 'white',
      '--nnj-row-bgcolor': 'white',
      '--nnj-header-cell-height': '50px',
      '--nnj-row-border-bottom': '1px solid #E5E5E5',
      '--nnj-header-font-size': '11px',
      '--nnj-header-color': 'black',
      height: 'auto !important',
    },
    headerRowHeight: 50,
    rowHeight: 50,
  },
  urls: {
    headerRowHeight: 50,
    rowHeight: 48,
    styles: {
      '--nnj-header-bgcolor': 'white',
      '--nnj-row-bgcolor': 'white',
      '--nnj-header-cell-height': '50px',
      '--nnj-row-border-bottom': '1px solid #E5E5E5',
      '--nnj-header-font-size': '11px',
      '--nnj-header-color': 'black',
    },
  },
  widget: {
    backgroundColor: 'white',
    styles: {
      '--nnj-header-bgcolor': 'white',
      '--nnj-row-bgcolor': 'white',
      '--nnj-header-cell-height': '50px',
      '--nnj-header-font-size': '11px',
      '--nnj-header-color': 'black',
      height: 'auto !important',
    },
    headerRowHeight: 50,
    rowHeight: 45,
  },
  'channels-widget': {
    backgroundColor: 'white',
    styles: {
      '--nnj-header-bgcolor': 'white',
      '--nnj-row-bgcolor': 'white',
      '--nnj-header-cell-height': '50px',
      '--nnj-header-font-size': '11px',
      '--nnj-header-color': 'black',
      height: 'auto !important',
    },
    headerRowHeight: 50,
    rowHeight: 40,
  },
};

export default NinjaTableGrid;
